import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  CssBaseline,
  Box,
  CircularProgress,
} from "@mui/material";
import api from "../utils/api";
import { useNavigate, useLocation } from "react-router-dom";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  // Get email from URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    if (emailParam) setEmail(emailParam);
  }, [location]);

  async function handleVerify(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMsg("");

    try {
      await api.post("/auth/verify-email", { email, otp });
      setMsg("Email verified successfully! You can now log in.");

      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(err.response?.data?.error || "OTP verification failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <CssBaseline />
      <Paper sx={{ p: 4, borderRadius: 3 }} elevation={6}>
        <Typography variant="h5" fontWeight={700} mb={2}>
          Verify Email
        </Typography>

        <Typography mb={3} color="text.secondary">
          Enter the OTP sent to your email.
        </Typography>

        <Box component="form" onSubmit={handleVerify}>
          <TextField
            label="Email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <TextField
            label="OTP"
            fullWidth
            margin="normal"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />

          {error && <Typography color="error">{error}</Typography>}
          {msg && <Typography color="green">{msg}</Typography>}

          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 2, py: 1.2 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "Verify Email"}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
